import { isNonProductionEnvironment } from "./isNonProductionEnvironment";
import { measureDownloadSpeed } from "./measureDownloadSpeed";

export const weakConnectionTypes = [
  'slow-2g',
  '2g',
  '3g',
];

// making 5 very small requests to measure the latency of each and take the average. ping.txt is an empty text file
const measureLatency = async (url = '/ping.txt', samples = 5) => {
  const latencies = [];

  for (let i = 0; i < samples; i++) {
    const requestStartTime = performance.now();
    await fetch(url + '?cacheBust=' + Math.random(), { method: 'HEAD' });
    latencies.push(performance.now() - requestStartTime);
  }

  const result = {
    averageLatency: Math.round(latencies.reduce((a, b) => a + b) / latencies.length),
    latencyTestValues: latencies,
  }

  return result;
}


const getConnectionQuality = async () => {
  const conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
  const downloadSpeedResult = await measureDownloadSpeed();
  const { status: downloadSpeedStatus, reason, mbps: downloadSpeed, bytesDownloaded } = downloadSpeedResult;
  const latencyResult = await measureLatency();
  const { averageLatency: latency, latencyTestValues } = latencyResult;
  

  // handling browsers that don't use Network Information API.
  if (!conn) {
    return {
      downlink: downloadSpeed,
      estimatedLatency: latency,
      effectiveType: null,
      isWeakConnectionType: downloadSpeed < 2,
    };
  }

  const isWeakConnectionType = !!weakConnectionTypes.find((connectionType) => (connectionType.includes(conn.effectiveType)));

  // creating log for QA purposes
  const QAConnectionQualityReport = {
    connectionType: conn.effectiveType,
    isWeakConnectionType,
    estimatedLatency: conn.rtt || latency,
    latencyTestValues,
    downloadSpeed,
    measuredDownloadSpeed: downloadSpeed,
    navigatorDownlinkSpeed: conn.downlink,
    downloadSpeedStatus: downloadSpeedStatus,
    downloadSpeedReason: reason,
    bytesDownloaded,
  };

  if (isNonProductionEnvironment()) {
    console.log(
      "%cConnection Quality Report",
      "color: lightgreen; font-weight: bold;",
      QAConnectionQualityReport,
    )
  }

  return {
    downlink: downloadSpeed,       // Mbps (estimated)
    downloadSpeedStatus,
    estimatedLatency: conn.rtt,                 // ms (estimated latency)
    effectiveType: conn.effectiveType, // 'slow-2g', '2g', '3g', '4g'
    isWeakConnectionType,
  };
}

export default getConnectionQuality;